export default {
  root: {
  },
  label: {
    border: '#E7FB4C',
  },
  textSecondary: {
  },
};
